module.exports = __webpack_public_path__ + "static/img/industriesbg3.19114e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriesbg3.jpg
// module id = TWUC
// module chunks = 1